import "@/App.css";
import AppHeader from "@/components/AppHeader";
import AppDock from "@/components/AppDock";
import Ticker from "@/components/Ticker";
import SideRails from "@/components/SideRails";
import BookingWizard from "@/components/booking/BookingWizard";
import ReviewsSlider from "@/components/ReviewsSlider";
import FaqSection from "@/components/FaqSection";

export default function App() {
  return (
    <div className="app-shell" data-testid="lunessa-booking-app">
      <AppHeader />
      <Ticker />
      <SideRails />
      <main className="app-main">
        <h1 className="sr-only">Sivas Masaj Salonu — Lunessa Spa Masaj Online Randevu</h1>
        <BookingWizard />
        <ReviewsSlider />
        <FaqSection />
      </main>
      <AppDock />
    </div>
  );
}
